export enum KycStatus {
  NOT_REFERRED = 'NOT_REFERRED',
  READY_FOR_KYC = 'READY_FOR_KYC',
  PERSONAL_INFO_FILLED = 'PERSONAL_INFO_FILLED',
  DUE_DILIGENCE_FILLED = 'DUE_DILIGENCE_FILLED',
  DUE_DILIGENCE_APPROVED = 'DUE_DILIGENCE_APPROVED',
  PAYMENT_PENDING = 'PAYMENT_PENDING',
  VALIDATED = 'VALIDATED',
}
